<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-file icon"></i>
        {{ directory.name }}
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administrativeHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'cellarsAdministrator' }">
                <span>
                  <i class="fas fa-boxes icon"></i>
                  Bodegas
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'documentsAdministrator', params: { id: directory.cellar_id } }">
                <span >
                  <i class="fas fa-file icon"></i>
                  Documentos
                </span>
              </router-link>
            </li>
            <transition name="fade" mode="out-in">
              <li style="width: 50%;" v-if="isBreadCrumbLoading">
                <div style="margin-right:10px !important">                  
                </div>
                <b-skeleton :animated="true"></b-skeleton>
              </li>
              <div style="display:flex; flex-direction: row" v-else>
                <li 
                  :class="directory.id == $route.params.id ? 'is-active' : ''"  
                  v-for="directory in directoryTree" 
                  :key="directory.id" 
                >
                  <router-link :to="{ path: `${directory.id}` }">
                    <span>
                      <i class="fas fa-folder icon"></i>
                      {{directory.name}}
                    </span>
                  </router-link>
                </li>
              </div>
            </transition>
          </ul>
        </nav>
      </div>
      <div slot="folders">
        <ListDirectory :chargeDocumentList="chargeDocumentList" :folder_id="$route.params.id"></ListDirectory>
      </div>
      <div slot="contenido">
        <div class="box">
          <b-button
            type="is-primary is-small"
            icon-left="plus"
            rounded
            @click="openCreate()"
            >Ingresar Documento</b-button
          >
          <b-button
            :disabled="checkedRows.length == 0"
            type="is-success is-small"
            icon-left="folder"
            rounded
            @click="addDocumentDirectory()"
            style="margin-left: 1%"
            >Trasladar a otra carpeta</b-button
          >

          <b-table
            type="is-primary"
            :data.sync="listDocument.data"
            :loading="loading"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-current-label="Current page"
            checkable
            :checkbox-position="'right'"
            :checked-rows.sync="checkedRows"
            detailed
            narrowed
              paginated
            backend-pagination
            :total="listDocument.total"
            :per-page="listDocument.per_page"
            @page-change="onPageChange"
          >
            <template slot-scope="props">
              <b-table-column field="favorite">
                <b-icon
                  v-if="props.row.favorite == '1'"
                  type="is-warning"
                  icon="star"
                  size="is-small"
                >
                </b-icon>
              </b-table-column>
              <b-table-column field="number" label="N° Documento" searchable>{{
                props.row.number
              }}</b-table-column>
              <b-table-column field="date_document" label="Fecha" searchable>
                <span class="tag is-success">
                 {{ formatDate(props.row.date_document)}}
                </span>
              </b-table-column>
              <b-table-column
                field="document_type.name"
                label="Tipo de Documento"
                searchable
                >{{ props.row.document_type.name }}</b-table-column
              >
              <b-table-column field="cellar.name" label="Bodega" searchable>{{
                props.row.cellar.name
              }}</b-table-column>

              <b-table-column label="Action" width="200px">
                <div class="buttons">
                   <b-button
                    type="is-primary is-small"
                    icon-left="edit"
                    @click="openModalEdit(props.row)"
                  ></b-button>
                  <b-button
                    type="is-primary is-small"
                    icon-left="search"
                    @click="openViewPdf(props.row.id)"
                  ></b-button>
                  <b-button
                    type="is-danger is-small"
                    icon-left="eject"
                    @click="removeDocument(props.row.id)"
                  ></b-button>
                  <a :href="props.row.file" target="_blank">
                    <b-button
                      type="is-primary is-small"
                      icon-left="download"
                    ></b-button>
                  </a>
                </div>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <article class="media">
                <div class="media-content">
                  <div class="content">
                    <p><b>Descripción:</b> {{ props.row.description }}</p>
                  </div>
                </div>
              </article>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import ViewPdf from "../../../components/administrative/document/ViewPdf";
import CreateDocument from "../../../components/administrative/document/CreateDocument";

import ListDirectory from "../../../components/administrative/directory/ListDirectory";
// import {
//   getDocument,
//   getDocumentsFindByDirectory,
//   updateDocument,
// } from "../../../services/document";
import addDocumentDirectory from "../../../components/general/directory/AddDocumentDirectory";
import { DocumentService } from '../../../services/models/document';
import { DirectoryService } from '../../../services/models/directory';
import moment from "moment";
import EditDocument from "../../../components/administrative/document/EditDocument.vue";

export default {
  components: {
    PlantillaContenido,
    ListDirectory
  },
  data() {
    return {
      isBreadCrumbLoading: true,
      user_type_id: null,
      listDocument: [],
      loading: false,
      checkedRows: [],
      directory: {
        name: "",
        cellar_id: null
      },
      directoryTree: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
       currentPage: 1,
      perPage: 15,
    };
  },
  watch: {
    $route() {
      this.chargeDocumentList();
    }
  },
  mounted: function () {
    this.chargeDocumentList();
  },
  methods: {
    formatDate(date){
      return moment(date).format('YYYY-MM-DD')
    },
    openModalEdit(document){            
      this.$buefy.modal.open({
        parent: this,
        component: EditDocument,
        fullScreen: true,
        props: {
          documentProp:document,
          chargeDocumentList:this.chargeDocumentList
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onPageChange(page) {
      this.chargeDocumentList(page);
    },
    openCreate() {
      this.$buefy.modal.open({
        parent: this,
        component: CreateDocument,
        fullScreen: true,
        props: {
          chargeDocumentList: this.chargeDocumentList,
          directory_id: this.$route.params.id,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    openViewPdf(id) {
      this.$buefy.modal.open({
        parent: this,
        component: ViewPdf,
        fullScreen: true,
        props: {
          id: id,
          chargeDocumentList: this.chargeDocumentList,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async chargeDocumentList(page = 1) {
      this.loading = true;
      this.directoryTree = [];
      this.getTree(this.$route.params.id);
      const {data : directory} = await DirectoryService.getById(this.$route.params.id);
      this.directory = directory;
      const {data : documents} = await DocumentService.getDocumentsFindByDirectory(this.$route.params.id,page);
      this.listDocument = documents;
      this.currentPage=documents.current_page,
      this.perPage= documents.per_page,
      // this.listDocument = await getDocumentsFindByDirectory(
      //   this.$http,
      //   this.$route.params.id
      // );
      this.loading = false;
    },
    async addDocumentDirectory() {
      this.$buefy.modal.open({
        parent: this,
        component: addDocumentDirectory,
        props: {
          checkedRows: this.checkedRows,
          chargeDocumentList: this.chargeDocumentList,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async getTree(folderId) {
      this.isBreadCrumbLoading = true;
      if (!folderId) {
        this.isBreadCrumbLoading = false;
        return
      }
      const {data : directory} = await DirectoryService.getById(folderId);
      this.directoryTree.unshift(directory);
      this.getTree(directory.dependency_id);
    },
    async removeDocument(id) {
      this.$buefy.dialog.confirm({
        title: "¿Desea sacar este documento de la actual carpeta?",
        message:
          "Una vez sacado el documento, ya no aparecerá en la carpeta actual",
        confirmText: "Sacar de la carpeta",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.loading = true;
          const { data: document } = await DocumentService.getById(id);
          // let document = document;
          // let document = await getDocument(this.$http, id);
          let data = {
            ...document,
            state_directory: "Sin Directorio",
            directory_id: null,
          };
          await DocumentService.update(id, data);
          // await updateDocument(this.$http, id, data);
          this.loading = false;
          await this.chargeDocumentList();
          this.$buefy.notification.open({
            message: `Documento N°${document.number} removido de la carpeta con exito`,
            type: "is-success",
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>